import { selectOdetTitleNode } from '@newStore/documentUI/transformContent/odetContentNodeSelectors';
import { type BuildingBlockNodeConfig, NodeType } from '@nodeTypeConfig/configTypes';
import { descriptionComponent } from '@nodeTypeConfig/helpers/editComponents/descriptionComponent';
import { identifierComponent } from '@nodeTypeConfig/helpers/editComponents/identifierComponent';
import { titleComponent } from '@nodeTypeConfig/helpers/editComponents/titleComponent';

const CURRICULUM_ODET_LEVEL: BuildingBlockNodeConfig = {
  nodeSelector: selectOdetTitleNode,
  information: {
    single: 'Soort',
    plural: 'Soorten',
  },

  buildingBlocks: [{ type: NodeType.CURRICULUM_ODET_KEY_COMPETENCE }],
  edit: [
    {
      ...identifierComponent,
      width: 2,
    },
    {
      ...titleComponent,
      width: 10,
    },
    descriptionComponent,
  ],
  isCollapsible: true,
  onNewNodeDropped: {
    focusOnField: 'title',
  },
};

export default CURRICULUM_ODET_LEVEL;
